var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "hide-header": "",
      "hide-footer": "",
      "centered": ""
    },
    model: {
      value: _vm.isShow,
      callback: function callback($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticStyle: {
      "flex-basis": "40%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.detailInfo.product.pic_url,
      "width": "100%",
      "height": "100%"
    }
  })]), _c('div', {
    staticClass: "ml-4"
  }, [_c('h4', [_vm._v(_vm._s(_vm.detailInfo.title))]), _c('h5', [_vm._v("商品頁序號：" + _vm._s(this.detailInfo.product.sale_page_code))]), _c('div', [_vm._v("單價：" + _vm._s(this.detailInfo.product.price))]), _c('div', [_vm._v("款式：" + _vm._s(this.detailInfo.product.sku))]), _c('b-form', {
    staticClass: "d-flex",
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "mr-sm-2"
  }, [_vm._v("購買數量：")]), _c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "number",
      "formatter": _vm.formatter
    },
    model: {
      value: _vm.quantity,
      callback: function callback($$v) {
        _vm.quantity = _vm._n($$v);
      },
      expression: "quantity"
    }
  }), _c('b-btn', {
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("更新網址")])], 1)], 1)]), _c('div', {
    staticClass: "border border-secondary mt-4 p-4"
  }, [_c('a', {
    attrs: {
      "href": _vm.payLink
    }
  }, [_vm._v(_vm._s(_vm.payLink))])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }